import { ArrowLeft } from "lucide-react";
import { Trans } from "react-i18next";
import { PageNavigation } from "../../components/layout/PageNavigation";
import { PageTitleRow } from "../../components/layout/PageTitleRow";
import { getEmployeeTitleSuffix } from "./employeeIdentity";

export default function OnboardingPageTitle({
  onBack, employeeId, employeeName, title, subtitle, titleClassName, subtitleClassName, action
}) {
  return (
    <PageNavigation>
      <div className="page-header">
        <PageTitleRow back={onBack ? (
          <button type="button" onClick={onBack}>
            <ArrowLeft aria-hidden="true" />
            <span><Trans i18nKey="formActions.back" /></span>
          </button>
        ) : null}>
          <h1 className={titleClassName}>{title}{getEmployeeTitleSuffix(employeeId, employeeName)}</h1>
          <p className={subtitleClassName}>{subtitle}</p>
        </PageTitleRow>
        {action ? <div className="page-header__actions">{action}</div> : null}
      </div>
    </PageNavigation>
  );
}
